import {
  signUpRequestAccess,
  signUpLinkedInConnect,
  signUpCVUpload,
} from '../segment'

;(function() {
  angular.module('app.ui.form.ctrls').controller('ProfileCtrl', [
    '$scope',
    '$http',
    '$location',
    '$log',
    '$upload',
    '$element',
    'sharedProperties',
    'currentLawyer',
    '$modal',
    'usSpinnerService',
    'logger',
    '$cookies',
    '$window',
    '$anchorScroll',
    '$filter',
    'userService',
    'accountPermission',
    '$timeout',
    function(
      $scope,
      $http,
      $location,
      $log,
      $upload,
      $element,
      sharedProperties,
      currentLawyer,
      $modal,
      usSpinnerService,
      logger,
      $cookies,
      $window,
      $anchorScroll,
      $filter,
      userService,
      accountPermission,
      $timeout
    ) {
      var applyErrorClasses
      var totalCvAttachedCounter
      $scope.startSpin = function() {
        if (!$scope.spinneractive && !$scope.recordFetched) {
          usSpinnerService.spin('spinner-2')
          $scope.spinneractive = true
          $scope.startcounter++
        }
      }

      $scope.stopSpin = function() {
        if ($scope.spinneractive) {
          usSpinnerService.stop('spinner-2')
          $scope.spinneractive = false
        }
      }

      function determineElementToEdit(elementId) {
        switch (elementId) {
          case 'select-jurisdiction':
            return 'jurisdiction'
          case 'edit-jurisdiction':
            return 'jurisdiction'
          case 'select-practices':
            return 'practice'
          case 'edit-practices':
            return 'practice'
          case 'select-locations':
            return 'location'
          case 'edit-locations':
            return 'location'
          default:
            return ''
        }
      }

      $scope.showPracticeTick = false
      $scope.showLocationsTick = false
      $scope.showCategoryTick = false
      $scope.showjurisdictionTick = false
      $scope.hidePQE = false
      $scope.editJurisdictions = false
      $scope.editPractices = false
      $scope.editLocations = false
      $scope.lawyerData = {}
      $scope.jurisdictions = []
      $scope.Class = ''
      $scope.newUser = true
      $scope.lawyerPractices = []
      $scope.lawyerLocations = []
      $scope.lawyerJurisdictions = []
      $scope.isCVAdded = false
      $scope.loggedInLawyer = {
        user: {
          first_Name: $cookies.firstName,
          last_Name: $cookies.lastName,
        },
        lawyer: {},
      }
      $scope.areas = []
      $scope.refPractices = []
      $scope.categories = []
      $scope.locations = []
      $scope.other = ''
      $scope.requestBtnCaption = 'Request Access'
      $scope.jurisdictionLabel = 'In which jurisdictions are you qualified?*'
      $scope.pqeLabel =
        'Date commenced practice (date of qualification or, if you are a trainee, expected date of qualification)*'
      $scope.linkedInRequired = true
      $scope.cvRequired = true
      $scope.modalData = {
        element: '',
        data: [],
      }

      $scope.currentEmpErrorClass = ''
      $scope.universityErrorClass = ''
      $scope.nationalityErrorClass = ''
      $scope.currLocationErrorClass = ''
      $scope.contactNumberErrorClass = ''

      $scope.pqeErrorClass = ''
      $scope.jurisdictionsErrorClass = ''
      $scope.practicesErrorClass = ''
      $scope.locationsErrorClass = ''
      $scope.regNumberErrorClass = ''
      $scope.cvErrorClass = ''
      $scope.requestAccessClass = 'btn btn-lg btn-info disabled'
      $scope.canEditNewbeeProfile = () => {
        return accountPermission.canNotEditNewUserProfile($scope.user)
      }

      $scope.profileValidation = function() {
        var count
        count = 0
        if ($scope.lawyerData.currentEmp) {
          count++
        }

        if ($scope.lawyerData.university) {
          count++
        }

        if ($scope.lawyerData.nationality) {
          count++
        }

        if ($scope.lawyerData.currentLocation) {
          count++
        }

        if ($scope.lawyerData.lawyer_phone) {
          count++
        }

        if ($scope.lawyerData.pqe) {
          count++
        }

        if ($scope.editJurisdictions) {
          count++
        }

        if ($scope.editPractices) {
          count++
        }

        if ($scope.editLocations) {
          count++
        }

        if (count === 9 && !$scope.loggedInLawyer.isAdmin && $scope.newUser) {
          return ($scope.requestAccessClass = 'btn btn-lg btn-info')
        }

        return $scope.requestBtnCaption === 'Access Requested'
          ? ($scope.requestAccessClass = 'btn btn-lg btn-info disabled')
          : ($scope.requestAccessClass = 'btn btn-lg btn-info')
      }

      $scope.connectToLinkedIn = function() {
        signUpLinkedInConnect()
        $window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77np1itngwj5tl&redirect_uri=${process.env.LEXSTEP_URL}/auth/linkedin/callback&state=fooobar&scope=r_liteprofile%20r_emailaddress`
        // $window.location.href = `${process.env.LEXSTEP_URL}/api/linkedin-auth`
      }

      $scope.pqeChanged = function() {
        $scope.pqeErrorClass = ''
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        $scope.lawyerData.tempPqe = angular.copy(
          new Date(
            new Date($scope.lawyerData.pqe).setMonth(
              $scope.lawyerData.pqe.getMonth() + 1
            )
          )
        )
        $http
          .post('/api/select-lawyer-pqe', $scope.lawyerData, {
            contentType: 'application/json',
          })
          .then(
            function({data, status, headers, config}) {
              var message
              message = 'Your PQE has been saved successfully'
            },
            function(error) {}
          )
        $scope.profileValidation()
      }

      let currentEmpUpdateInProgress = false
      $scope.currentEmpChanged = function() {
        if (!currentEmpUpdateInProgress) {
          currentEmpUpdateInProgress = true
          $timeout(() => {
            var temporaryEmployer = {}
            if (
              $scope.lawyerData.currentEmp &&
              $scope.lawyerData.currentEmp.firm_ID
            ) {
              temporaryEmployer.firm_name =
                $scope.lawyerData.currentEmp.user.firm_Name
              temporaryEmployer.ref_firm_ID =
                $scope.lawyerData.currentEmp.firm_ID
            } else {
              temporaryEmployer.firm_name = $scope.lawyerData.currentEmp
              temporaryEmployer.ref_firm_ID = null
            }

            $scope.lawyerData.employer = temporaryEmployer
            temporaryEmployer.user_ID = $scope.loggedInLawyer.user.user_ID
            if (temporaryEmployer.firm_name !== void 0) {
              $http
                .post('/api/select-lawyer-currentEmp', temporaryEmployer, {
                  contentType: 'application/json',
                })
                .then(
                  function({data, status, headers, config}) {
                    var message
                    message =
                      'Your current employer has been saved successfully'
                    currentEmpUpdateInProgress = false
                  },
                  function(error) {}
                )
            } else {
              currentEmpUpdateInProgress = false
            }
          }, 500)
        }
      }

      let universityUpdateInProgress = false
      $scope.universityChanged = function() {
        if (!universityUpdateInProgress) {
          universityUpdateInProgress = true
          $timeout(() => {
            $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
            if ($scope.lawyerData.university !== void 0) {
              $http
                .post('/api/select-lawyer-university', $scope.lawyerData, {
                  contentType: 'application/json',
                })
                .then(
                  function({data, status, headers, config}) {
                    var message
                    message = 'Your University has been saved successfully'
                    universityUpdateInProgress = false
                  },
                  function(error) {}
                )
            }
          }, 500)
        }
      }

      $scope.degreeDateChanged = function() {
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        if ($scope.lawyerData.degree_date !== void 0) {
          $http
            .post('/api/select-lawyer-degree_date', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                message =
                  'Your Degree completion date has been saved successfully'
              },
              function(error) {}
            )
        }
      }

      $scope.nationalityChanged = function() {
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        if ($scope.lawyerData.nationality !== void 0) {
          $http
            .post('/api/select-lawyer-nationality', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                message = 'Your nationality has been saved successfully'
              },
              function(error) {}
            )
        }
      }

      $scope.currentLocationChanged = function() {
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        if ($scope.lawyerData.currentLocation !== void 0) {
          $http
            .post('/api/select-lawyer-current-location', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                message = 'Your current location has been saved successfully'
              },
              function(error) {}
            )
        }
      }

      $scope.phoneNumberChanged = function() {
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        if ($scope.lawyerData.lawyer_phone !== void 0) {
          $http
            .post('/api/select-lawyer-phone', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                message = 'Your phone number has been saved successfully'
              },
              function(error) {}
            )
        }
      }

      $scope.sraIdChanged = function() {
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        if ($scope.lawyerData.regNumber !== void 0) {
          $scope.regNumberErrorClass = ''
          $http
            .post('/api/select-lawyer-sraId', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                message = 'Your current location has been saved successfully'
              },
              function(error) {}
            )
        }
      }

      $scope.linkedInURLChanged = function() {
        if (
          $scope.lawyerData.linkedInURL !== void 0 &&
          $scope.lawyerData.linkedInURL !== ''
        ) {
          $http
            .post('/api/select-lawyer-linkedIn', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                $scope.linkedInRequired = false
                message =
                  'Your current linkedIn profile link has been saved successfully'
              },
              function(error) {}
            )
        } else {
          $scope.linkedInRequired = true
        }
      }

      $scope.requiresSponsorshipChanged = function() {
        $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID
        if ($scope.lawyerData.reqSponsorship !== void 0) {
          $http
            .post('/api/select-lawyer-sponsorship', $scope.lawyerData, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                message = 'Your sponsorship status has been saved successfully'
              },
              function(error) {}
            )
        }
      }

      $scope.fetchLawyerData = function() {
        $http
          .post('/api/fetch-lawyer-locations', {
            id: $scope.loggedInLawyer.lawyer.lawyer_ID,
          })
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerLocations = data
              $scope.mapLocations()
            },
            function({data, status}) {
              if (status === 440) {
                $location.url('/signin')
              }
            }
          )
        $http
          .post('/api/fetch-lawyer-practices', {
            id: $scope.loggedInLawyer.lawyer.lawyer_ID,
          })
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerPractices = data
              $scope.mapPractices()
            },
            function({data, status}) {
              if (status === 440) {
                $location.url('/signin')
              }
            }
          )
        $http
          .post('/api/fetch-lawyer-jurisdictions', {
            id: $scope.loggedInLawyer.lawyer.lawyer_ID,
          })
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerJurisdictions = data
              $scope.mapJurisdictions()
            },
            function({data, status}) {
              if (status === 440) {
                $location.url('/signin')
              }
            }
          )
      }

      $scope.mapLocations = function() {
        $scope.locations = []
        $scope.refLocations.forEach(function(loc) {
          return $scope.lawyerLocations.forEach(function(lLoc) {
            if (lLoc.refLocationLocID === loc.loc_ID) {
              loc.isSelected = true
              $scope.showLocationsTick = true
              $scope.editLocations = true
              if (!loc.hasChild) {
                return $scope.locations.push(loc)
              }
            }
          })
        })
        $scope.lawyerLocations.forEach(function(lawyerloc, index, array) {
          return $scope.nrefLocations.forEach(function(refloc, index, array) {
            if (lawyerloc.loc_ID === refloc.loc_ID) {
              refloc.isSelected = true
              if (!refloc.hasChild) {
                $scope.locations.push(refloc)
              }

              if (refloc.hasChild) {
                if (refloc.locations) {
                  refloc.locations.forEach(function(loc, index, array) {
                    if (loc.hasChild) {
                      return loc.sub_areas.forEach(function(sub, index, array) {
                        return $scope.refLocations.push(sub)
                      })
                    }

                    return $scope.refLocations.push(loc)
                  })
                } else if (refloc.sub_areas) {
                  refloc.sub_areas.forEach(function(sub, index, array) {
                    return $scope.refLocations.push(sub)
                  })
                }
              } else {
                $scope.refLocations.push(refloc)
              }
            }
          })
        })
      }

      $scope.areasToShow = []
      $scope.mapPractices = function() {
        $scope.lawyerPractices.forEach(function(lawyer_area, index, array) {
          $scope.areas.forEach(function(area, index, array) {
            if (lawyer_area.refPracticePracticeID === area.practice_ID) {
              lawyer_area.practice_name = area.practice_name
              lawyer_area.law_area = area.law_area
              lawyer_area.hasChild = area.hasChild
              if (lawyer_area.isSelected) {
                area.isSelected = true
                $scope.editPractices = true
                $scope.showPracticeTick = true
              }
            }
          })
        })
        $scope.profileValidation()
      }

      $scope.mapJurisdictions = function() {
        $scope.lawyerJurisdictions.forEach(function(lawyer_juri, index, array) {
          $scope.locations.forEach(function(location, index, array) {
            if (lawyer_juri.refJurisdictionLocID === location.loc_ID) {
              lawyer_juri.loc_name = location.loc_name
              lawyer_juri.isSelected = true
            }
          })
          $scope.jurisdictions.forEach(function(juri, index, array) {
            if (lawyer_juri.refJurisdictionLocID === juri.loc_ID) {
              juri.isSelected = true
              $scope.editJurisdictions = true
              $scope.showjurisdictionTick = true
            }
          })
        })
        $scope.other = $scope.loggedInLawyer.lawyer.other_Jurisdictions
        if ($scope.other) {
          $scope.editJurisdictions = true
          $scope.showjurisdictionTick = true
        }

        $scope.isEnglandWalesSelected = _.findWhere($scope.jurisdictions, {
          loc_ID: 20,
        }).isSelected
        $scope.profileValidation()
      }

      $scope.jumpToLink = function(id) {
        var oldHash
        oldHash = $location.hash()
        $location.hash(id)
        $anchorScroll()
        $location.hash(oldHash)
      }

      $scope.populateLawyerDate = function() {
        $scope.lawyerData.currentEmp = angular.copy(
          $scope.loggedInLawyer.lawyer.lawyer_currentEmp
        )
        $scope.lawyerData.university = angular.copy(
          $scope.loggedInLawyer.lawyer.university
        )
        $scope.lawyerData.nationality = angular.copy(
          $scope.loggedInLawyer.lawyer.nationality
        )
        $scope.lawyerData.currentLocation = angular.copy(
          $scope.loggedInLawyer.lawyer.currentLocation
        )
        $scope.lawyerData.reqSponsorship = angular.copy(
          $scope.loggedInLawyer.lawyer.reqSponsorship
        )
        $scope.lawyerData.lawyer_phone = angular.copy(
          $scope.loggedInLawyer.lawyer.lawyer_phone
        )
        $scope.lawyerData.pqe = angular.copy($scope.loggedInLawyer.lawyer.PQE)
        $scope.lawyerData.regNumber = angular.copy(
          $scope.loggedInLawyer.lawyer.lawyer_regNumber
        )
        $scope.lawyerData.linkedInURL = angular.copy(
          $scope.loggedInLawyer.lawyer.linkedInURL
        )
        $scope.lawyerData.linkedInData = angular.copy(
          $scope.loggedInLawyer.lawyer.linkedInData
        )
        $scope.selectedFile = $scope.loggedInLawyer.user.user_CV
        $scope.fetchLawyerData()
        $scope.cvRequired = !$scope.selectedFile
        if ($scope.hasLawyerAppliedForApproval) {
          if ($scope.lawyerStatus === 'Approved') {
            $scope.refreshUser()
            $location.url(
              $scope.loggedInLawyer.isAdmin
                ? '/admin/lawyer-profile'
                : '/user-profile'
            )
          }

          $scope.newUser = $scope.lawyerStatus === 'NewUser'
          $scope.requestBtnCaption = $scope.newUser
            ? 'Request Access'
            : 'Access Requested'
        } else {
          $scope.newUser = true
        }

        $scope.profileValidation()
      }

      if ($location.search().user) {
        $http
          .post(
            '/api/fetch-lawyer-by-referral-code',
            {user: $location.search().user},
            {
              contentType: 'application/json',
            }
          )
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerStatus = data.lawyer.lawyer_Status
              $scope.hasLawyerAppliedForApproval = data.lawyer.hasApplied
              $scope.loggedInLawyer = data
              $scope.populateLawyerDate()
            },
            function({data, status}) {
              if (status === 440) {
                $location.url('/signin')
              }
            }
          )
      } else {
        $http
          .post('/api/fetch-current-lawyer', {
            contentType: 'application/json',
          })
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerStatus = data.lawyer.lawyer_Status
              $scope.hasLawyerAppliedForApproval = data.lawyer.hasApplied
              $scope.loggedInLawyer = data
              $scope.populateLawyerDate()
            },
            function({data, status}) {
              if (status === 440) {
                $location.url('/signin')
              }
            }
          )
      }

      $scope.lawyerPractices = []
      $scope.lawyerLocations = []
      $scope.lawyerJurisdictions = []
      $scope.loggedInLawyer = {}
      $scope.areas = []
      $scope.categories = []
      $scope.locations = []
      $scope.nrefLocations = []
      $scope.selectedFile = ''
      totalCvAttachedCounter = 1
      $scope.upload = function(files) {
        var file
        var fileFlag
        var fileType
        var index
        var indexConvert
        var indexFileSize
        var modifiedFileName
        var sFileExtension
        var sFileName
        if (files && files.length) {
          index = 0
          fileType = ''
          fileFlag = 1
          $scope.imgSrc = ''
          this.uploadURL = ''
          while (index < files.length) {
            file = files[index]
            sFileName = file.name
            modifiedFileName = sFileName
            sFileExtension = sFileName
              .split('.')
              [sFileName.split('.').length - 1].toLowerCase()
            if (totalCvAttachedCounter > 1) {
              $scope.selectedFile =
                sharedProperties.setCVName(
                  $scope.loggedInLawyer.user.first_Name,
                  $scope.loggedInLawyer.user.last_Name,
                  $scope.loggedInLawyer.user.cv_counter
                ) +
                '_' +
                totalCvAttachedCounter +
                '.' +
                sFileExtension
            } else {
              $scope.selectedFile =
                sharedProperties.setCVName(
                  $scope.loggedInLawyer.user.first_Name,
                  $scope.loggedInLawyer.user.last_Name,
                  $scope.loggedInLawyer.user.cv_counter
                ) +
                '.' +
                sFileExtension
            }

            indexFileSize = file.size
            indexConvert = (file.size / 1048576).toFixed(2)
            if (
              sFileExtension === 'pdf' ||
              sFileExtension === 'doc' ||
              sFileExtension === 'docx'
            ) {
              fileType = 'resume'
              this.uploadURL = '/api/upload-cv-before-approval'
              modifiedFileName =
                totalCvAttachedCounter > 1
                  ? sharedProperties.setCVName(
                      $scope.loggedInLawyer.user.first_Name,
                      $scope.loggedInLawyer.user.last_Name,
                      $scope.loggedInLawyer.user.cv_counter
                    ) +
                    '_' +
                    totalCvAttachedCounter +
                    '.' +
                    sFileExtension
                  : sharedProperties.setCVName(
                      $scope.loggedInLawyer.user.first_Name,
                      $scope.loggedInLawyer.user.last_Name,
                      $scope.loggedInLawyer.user.cv_counter
                    ) +
                    '.' +
                    sFileExtension

              totalCvAttachedCounter += 1
              fileFlag = 1
              $scope.startSpin('spinner-2')
            } else {
              $scope.selectedFile = null
              logger.notify(
                'error',
                'Incorrect format selection. Please try again.'
              )
              return false
            }

            $upload
              .upload({
                url: '/api/upload-cv-before-approval',
                data: {
                  id: $scope.loggedInLawyer.user.user_ID,
                  name: fileType + '.' + sFileExtension,
                  modifiedFileName: modifiedFileName,
                },
                file: file,
                sendObjectsAsJsonBlob: false,
              })
              .progress(function(event_) {
                var progressPercentage
                progressPercentage = Number.parseInt(
                  (100 * event_.loaded) / event_.total
                )
              })
              .then(function({data, status, headers, config}) {
                if (fileFlag === 1) {
                  signUpCVUpload()
                }

                $scope.isCVAdded = true
                $scope.cvRequired = false
                $scope.loggedInLawyer.user.user_CV = $scope.selectedFile
                $scope.stopSpin('spinner-2')
                if (!fileFlag) {
                  $http
                    .post('/api/get-profile-pic', {
                      id: $scope.loggedInLawyer.user.user_ID,
                    })
                    .then(
                      function({data, status, headers, config}) {
                        if (data && data.contains('https') == true) {
                          $scope.picSrc = data
                        } else
                          $scope.picSrc = sharedProperties.getImgSrc(
                            data,
                            $scope.loggedInLawyer.user.user_ID,
                            true
                          )
                      },
                      function({data, status}) {
                        if (status === 440) {
                          $location.url('/signin')
                        }
                      }
                    )
                }
              })
            index++
          }
        }
      }

      this.logOut = function() {
        sharedProperties.logOut()
      }

      this.referFriend = function() {
        $location.url('/refer-friend')
      }

      this.firmsAndJobs = function() {
        $location.url('/opportunities')
      }

      this.loadProfile = function() {
        $location.url('/profile')
      }

      $scope.openModal = function(event) {
        var id
        var modalInstance
        id = event.target.attributes.id.value
        $scope.modalData = {
          displayNextFunctionality: true,
          element: '',
          data: [],
        }

        // Determine Whether the change being made is for either jurisdictions, locations or practice areas
        if (
          _.include(
            [
              'select-locations',
              'select-practices',
              'select-jurisdiction',
              'edit-jurisdiction',
              'edit-practices',
              'edit-locations',
            ],
            id
          )
        ) {
          // Set required values in order to update jurisdictions, locations and practice areas
          angular.extend($scope.modalData, {
            element: determineElementToEdit(id),
            data: {
              locations: angular.copy($scope.nrefLocations),
              practiceAreas: angular.copy($scope.refPractices),
              jurisdictions: angular.copy($scope.jurisdictions),
            },
            linearPractices: angular.copy($scope.areasToShow),
            otherJurisdictions: !_.isEmpty($scope.other) ? $scope.other : '',
          })
        } else if (id === 'select-categories') {
          $scope.modalData.element = 'category'
          $scope.tempCategories = angular.copy($scope.categories)
          $scope.modalData.data = $scope.tempCategories
        }

        modalInstance = $modal.open({
          templateUrl: 'ModalScript.html',
          controller: 'CreateProfileModalCtrl',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function() {
              return $scope.modalData
            },
          },
        })
        return modalInstance.result.then(
          function(selectedItem) {
            // Determine Whether the change was made for either of the two
            // locations or practice areas
            if (
              _.include(
                ['practice', 'location', 'jurisdiction'],
                selectedItem.element
              )
            ) {
              // 'practice' added in condition only for the sake of understanding
              // its not that the returning element property will contain this string
              // because of the Next button feature for locations and Practice Areas
              // will always be 'location'

              // Update Jurisdictions If User changed them
              if (!_.isEmpty(selectedItem.jurisdictions)) {
                updateselectedJurisdictions({
                  currentLawyer:
                    $scope.loggedInLawyer.user &&
                    $scope.loggedInLawyer.user.user_ID,
                  updated_data: selectedItem.jurisdictions,
                  otherJurisdictions: !_.isEmpty(
                    selectedItem.otherJurisdictions
                  )
                    ? selectedItem.otherJurisdictions
                    : '',
                })
              }

              // Update Practice areas If User changed them
              if (!_.isEmpty(selectedItem.linearPractices))
                updateSeletedPractices({
                  currentLawyer:
                    $scope.loggedInLawyer.lawyer &&
                    $scope.loggedInLawyer.lawyer.lawyer_ID,
                  updated_data: selectedItem.practiceAreas,
                  linearPractices: selectedItem.linearPractices,
                })

              // Update Locations If User changed them
              if (!_.isEmpty(selectedItem.locations))
                updateSeletedLocations({
                  currentLawyer:
                    $scope.loggedInLawyer.lawyer &&
                    $scope.loggedInLawyer.lawyer.lawyer_ID,
                  updated_data: selectedItem.locations,
                })
            } else if (selectedItem.element === 'category') {
              $scope.tempCategories = angular.copy(selectedItem.data)
              $scope.requestedData = {
                currentLawyer: $scope.loggedInLawyer.user.user_ID,
                updated_data: angular.copy($scope.tempCategories),
              }
              $scope.selectCategories($scope.requestedData)
            }
          },
          function() {
            $scope.profileValidation()
            $scope.tempJurisdictions = {}
          }
        )
      }

      function updateselectedJurisdictions(request) {
        var count = 0
        var message = ''
        $scope.isEnglandWalesSelected = _.findWhere(request.updated_data, {
          loc_ID: 20,
        }).isSelected
        $scope.selectedJurisdictions = []

        request.updated_data.forEach(jurisdiction => {
          if (jurisdiction.isSelected) {
            count++
            $scope.selectedJurisdictions.push(jurisdiction.loc_name)
          }
        })

        request.otherJurisdictions &&
          $scope.selectedJurisdictions.push(request.otherJurisdictions)

        if (count > 0 || request.otherJurisdictions) {
          $http
            .post('/api/select-lawyer-jurisdictions', request, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                $scope.jurisdictions = request.updated_data

                $http
                  .post('/api/select-lawyer-otherJurisdictions', request, {
                    contentType: 'application/json',
                  })
                  .then(
                    function({data, status, headers, config}) {
                      $scope.other = request.otherJurisdictions
                      $scope.showjurisdictionTick = true
                      $scope.editJurisdictions = true
                      $scope.profileValidation()
                    },
                    function(error) {}
                  )
              },
              function(error) {}
            )
        } else {
          logger.notify(
            'error',
            'This is a required field, you need to provide at least one jurisdiction.'
          )
        }

        $scope.profileValidation()
      }

      function updateSeletedLocations(request) {
        var count
        var message
        count = 0
        request.updated_data.forEach(function(location, index, array) {
          if (location.isSelected) {
            location.locations.forEach(function(loc, index, array) {
              if (loc.isSelected) {
                count++
                loc.sub_areas.forEach(function(sub, index, array) {
                  if (sub.isSelected) {
                    count++
                  }
                })
              }
            })
          }
        })
        request.currentLawyer = $scope.loggedInLawyer.lawyer.lawyer_ID
        if (count > 0) {
          $http
            .post('/api/update-lawyer-locations', request, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                $scope.locations = []
                $scope.nrefLocations = angular.copy(request.updated_data)
                request.updated_data.forEach(function(location, index, array) {
                  if (location.isSelected) {
                    location.locations.forEach(function(loc, index, array) {
                      if (loc.isSelected) {
                        if (!loc.hasChild) {
                          $scope.locations.push(loc)
                        }

                        loc.sub_areas.forEach(function(sub, index, array) {
                          if (sub.isSelected) {
                            $scope.locations.push(sub)
                          }
                        })
                      }
                    })
                  }
                })
                $scope.showLocationsTick = true
                $scope.editLocations = true
                $scope.profileValidation()
              },
              function(error) {}
            )
        } else {
          $scope.profileValidation()
          message =
            'This is a required field, you have to choose at least one location.'
          logger.notify('error', message)
        }
      }

      $scope.selectCategories = function(request) {
        var count
        var message
        count = 0
        request.updated_data.forEach(function(category, index, array) {
          if (category.isSelected) {
            count++
          }
        })
        if (count > 0) {
          $http
            .post('/api/select-lawyer-categories', request, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                var message
                $scope.category = angular.copy(request.updated_data)
                message = 'Your Firm Categories have been saved successfully'
                $scope.showCategoryTick = true
              },
              function(error) {}
            )
        } else {
          message =
            'This is a required field, you have to choose at least one firm type.'
          logger.notify('error', message)
        }
      }

      function updateSeletedPractices(request) {
        var count
        var message
        count = 0
        $scope.selectedPracAreas = []
        request.linearPractices.forEach(function(practice, index, array) {
          if (practice.isSelected) {
            count++
            if (practice.hasChild === false) {
              $scope.selectedPracAreas.push(practice.practice_name)
            }
          }
        })
        if (count > 0) {
          $http
            .post('/api/select-lawyer-practices', request, {
              contentType: 'application/json',
            })
            .then(
              function({data, status, headers, config}) {
                $scope.areas = angular.copy(request.linearPractices)
                $scope.areasToShow = angular.copy(request.linearPractices)
                $scope.refPractices = angular.copy(request.updated_data)
                $scope.showPracticeTick = true
                $scope.editPractices = true
                $scope.profileValidation()
              },
              function(error) {}
            )
        } else {
          message =
            'This is a required field, you have to choose at least one practice area.'
          logger.notify('error', message)
        }

        $scope.profileValidation()
      }

      $scope.applyForApproval = function() {
        $scope.requestAccessClass = 'btn btn-lg btn-info disabled'
        var message
        if (!$scope.lawyerData.employer) {
          $scope.lawyerData.employer = {
            firm_name: $scope.loggedInLawyer.lawyer.lawyer_currentEmp,
            ref_firm_ID: $scope.loggedInLawyer.lawyer.firmFirmID,
          }
        }

        if ($scope.validateForm()) {
          if (
            $scope.lawyerData.pqe === '' ||
            $scope.lawyerData.pqe === null ||
            typeof $scope.lawyerData.pqe === 'undefined'
          ) {
            $scope.pqeErrorClass = 'input-error'
            message = 'Please complete all fields before requesting access'
            logger.notify('error', message)
          } else {
            $scope.counter = 0

            if ($scope.cvRequired) {
              $scope.counter++
            }

            if (
              $scope.lawyerData.linkedInURL === '' ||
              $scope.lawyerData.linkedInURL === null ||
              typeof $scope.lawyerData.linkedInURL === 'undefined'
            ) {
              $scope.counter++
            }

            if (
              $scope.lawyerData.linkedInData === '' ||
              $scope.lawyerData.linkedInData === null ||
              typeof $scope.lawyerData.linkedInData === 'undefined'
            ) {
              $scope.counter++
            }

            if (
              $scope.lawyerData.regNumber === '' ||
              $scope.lawyerData.regNumber === null ||
              typeof $scope.lawyerData.regNumber === 'undefined' ||
              !$scope.isEnglandWalesSelected
            ) {
              $scope.counter++
            }

            if ($scope.counter < 4) {
              $scope.newUser = false
              $scope.lawyerData.lawyer_ID =
                $scope.loggedInLawyer.lawyer.lawyer_ID
              const request = {
                university: $scope.lawyerData.university,
                nationality: $scope.lawyerData.nationality,
                currentLocation: $scope.lawyerData.currentLocation,
                lawyer_phone: $scope.lawyerData.lawyer_phone,
                pqe: $scope.lawyerData.pqe,
                regNumber: $scope.lawyerData.regNumber,
                linkedInURL: $scope.lawyerData.linkedInURL,
                employer: $scope.lawyerData.employer,
                user_ID: $scope.lawyerData.user_ID,
                tempPqe: $scope.lawyerData.tempPqe,
                lawyer_ID: $scope.lawyerData.lawyer_ID,
              }

              signUpRequestAccess(
                $scope.lawyerData.nationality,
                $scope.lawyerData.currentLocation,
                $scope.lawyerData.lawyer_phone,
                $scope.lawyerData.pqe,
                $scope.selectedJurisdictions,
                $scope.selectedPracAreas,
                $scope.isEnglandWalesSelected || false,
                Boolean($scope.lawyerData.linkedInURL),
                $scope.isCVAdded
              )

              // $http.post('/api/apply-for-approval', $scope.lawyerData, {
              $http
                .post('/api/apply-for-approval', request, {
                  contentType: 'application/json',
                })
                .then(
                  function({data, status, headers, config}) {
                    message = 'Your request has been sent to admin for Approval'

                    $scope.requestAccessClass = 'btn btn-lg btn-info disabled'

                    $scope.newUser = false
                    $http
                      .post('/api/fetch-current-lawyer', {
                        contentType: 'application/json',
                      })
                      .then(
                        function({data, status, headers, config}) {
                          $scope.requestBtnCaption = 'Access Requested'
                          $scope.loggedInLawyer = data
                          $scope.fetchLawyerData()
                        },
                        function({data, status}) {
                          $scope.newUser = true
                          if (status === 440) {
                            $location.url('/signin')
                          }
                        }
                      )
                  },
                  function(error) {
                    $scope.requestAccessClass = 'btn btn-lg btn-info'
                    return ($scope.newUser = true)
                  }
                )
            } else {
              $scope.regNumberErrorClass = 'input-error'
              message = 'Please complete all fields before requesting access'
              $scope.requestAccessClass = 'btn btn-lg btn-info'
              logger.notify('error', message)
            }
          }
        } else {
          $scope.requestAccessClass = 'btn btn-lg btn-info'
          message = 'Please complete all fields before requesting access'
          logger.notify('error', message)
        }
      }

      $scope.formIsValid = function() {
        var area_count
        var juri_count
        juri_count = 0
        area_count = 0
        if ($scope.other && $scope.other !== '') {
          juri_count++
        }

        $scope.jurisdictions.forEach(function(juri, index, array) {
          if (juri.isSelected) {
            return juri_count++
          }
        })
        $scope.areas.forEach(function(area, index, array) {
          if (area.isSelected) {
            return area_count++
          }
        })
        applyErrorClasses(juri_count, area_count)
        if (area_count === 0 || juri_count === 0) {
          return false
        }

        return true
      }

      $scope.validateForm = function() {
        let isValid = true
        let area_count
        let juri_count
        let loc_count
        juri_count = 0
        area_count = 0
        loc_count = 0
        if ($scope.other && $scope.other !== '') {
          juri_count++
        }

        $scope.jurisdictions.forEach(function(juri, index, array) {
          if (juri.isSelected) {
            return juri_count++
          }
        })
        $scope.areas.forEach(function(area, index, array) {
          if (area.isSelected) {
            return area_count++
          }
        })
        applyErrorClasses(juri_count, area_count)

        if (juri_count === 0 || area_count === 0) {
          isValid = false
        }

        if ($scope.locations.length === 0) {
          isValid = false
        }

        if (_.isEmpty($scope.lawyerData.currentEmp)) {
          isValid = false
          $scope.currentEmpErrorClass = 'input-error'
        }

        if (_.isEmpty($scope.lawyerData.university)) {
          isValid = false
          $scope.universityErrorClass = 'input-error'
        }

        if (_.isEmpty($scope.lawyerData.nationality)) {
          isValid = false
          $scope.nationalityErrorClass = 'input-error'
        }

        if (_.isEmpty($scope.lawyerData.currentLocation)) {
          isValid = false
          $scope.currLocationErrorClass = 'input-error'
        }

        if (_.isEmpty($scope.lawyerData.lawyer_phone)) {
          isValid = false
          $scope.contactNumberErrorClass = 'input-error'
        }

        return isValid
      }

      applyErrorClasses = function(juri_count, area_count) {
        if (
          $scope.lawyerData.pqe === '' ||
          $scope.lawyerData.pqe === null ||
          typeof $scope.lawyerData.pqe === 'undefined'
        ) {
          $scope.pqeErrorClass = 'input-error'
        }

        if (juri_count === 0) {
          $scope.jurisdictionsErrorClass = 'input-error'
        }

        if (area_count === 0) {
          $scope.practicesErrorClass = 'input-error'
        }

        if ($scope.locations.length === 0) {
          $scope.locationsErrorClass = 'input-error'
        }

        if (
          $scope.cvRequired &&
          ($scope.lawyerData.linkedInURL === '' ||
            $scope.lawyerData.linkedInURL === null ||
            typeof $scope.lawyerData.linkedInURL === 'undefined') &&
          ($scope.lawyerData.regNumber === '' ||
            $scope.lawyerData.regNumber === null ||
            typeof $scope.lawyerData.regNumber === 'undefined' ||
            !$scope.isEnglandWalesSelected)
        ) {
          $scope.cvErrorClass = 'input-error'
        } else {
          $scope.cvErrorClass = ''
        }
      }

      $scope.populateCategory = function(data) {
        $scope.categories = data
      }

      $scope.populateLocation = function(data) {
        $scope.lawyerLocations.forEach(function(lawyerloc, index, array) {
          return data.forEach(function(refloc, index, array) {
            if (lawyerloc.loc_ID === refloc.loc_ID) {
              refloc.isSelected = true
            }
          })
        })
        data.forEach(function(loc, index, array) {
          if (loc.region === null && loc.area === null) {
            loc.locations = []
            $scope.nrefLocations.push(loc)
            data.forEach(function(region_area, index, array) {
              if (
                region_area.region === loc.loc_ID &&
                region_area.area === null
              ) {
                region_area.sub_areas = []
                loc.locations.push(region_area)
                data.forEach(function(sub_area, index, array) {
                  if (
                    sub_area.region !== null &&
                    sub_area.area === region_area.loc_ID
                  ) {
                    region_area.sub_areas.push(sub_area)
                  }
                })
              }
            })
          }
        })
        $scope.refLocations = data
      }

      $scope.areasToShow = []
      $http
        .post('/api/profile-practice-areas', {
          contentType: 'application/json',
        })
        .then(
          function({data, status, headers, config}) {
            $scope.areas = data
            $scope.areas.forEach(function(area, index, array) {
              $scope.areasToShow.push(area)
              if (area.law_area === null && area.practice_area === null) {
                area.practices = []
                $scope.refPractices.push(area)
                $scope.areas.forEach(function(prac_area, index, array) {
                  if (
                    prac_area.law_area === area.practice_ID &&
                    prac_area.practice_area === null
                  ) {
                    prac_area.sub_areas = []
                    area.practices.push(prac_area)
                    $scope.areas.forEach(function(sub_area, index, array) {
                      if (
                        sub_area.law_area !== null &&
                        sub_area.practice_area === prac_area.practice_ID
                      ) {
                        prac_area.sub_areas.push(sub_area)
                      }
                    })
                  }
                })
              }
            })
          },
          function({data, status}) {
            if (status === 440) {
              $location.url('/signin')
            }
          }
        )
      $http
        .post('/api/profile-category', {
          contentType: 'application/json',
        })
        .then(
          function({data, status, headers, config}) {
            $scope.populateCategory(data)
          },
          function(error) {
            if (status === 440) {
              $location.url('/signin')
            }
          }
        )
      $http
        .post('/api/profile-location', {
          contentType: 'application/json',
        })
        .then(
          function({data, status, headers, config}) {
            $scope.populateLocation(data)
          },
          function({data, status}) {
            if (status === 440) {
              $location.url('/signin')
            }
          }
        )
      $http
        .post('/api/profile-jurisdiction', {
          contentType: 'application/json',
        })
        .then(
          function({data, status, headers, config}) {
            $scope.jurisdictions = data
          },
          function({data, status}) {
            if (status === 440) {
              $location.url('/signin')
            }
          }
        )
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/user-profile/ProfileCtrl.js